// Components
import registerSketch from '../../../../common/drawings/sketches/index';
import presentationalComponent from './Sketch';
import containerComponent from './SketchContainer';
import modalComponent from './modal/LoadableSketchModal';

// Constants
import { TOOLS } from '../../../workspace/toolbar/toolbarConstants';
import { TOOLBAR_TOOLS, TOOL_SETS } from '../../../workspace/toolbarV2/config/toolbarToolConfig';

export default () =>
    registerSketch({
        presentationalComponent,
        containerComponent,
        modalComponent,
        tools: [
            {
                ...TOOLS.COLOR,
                name: 'Background',
            },
            TOOLS.EDIT_DRAWING,
            TOOLS.CAPTION,
            TOOLS.REACTION,
        ],
        selectedTools: [
            { ...TOOLBAR_TOOLS.COLOR, name: 'Background' },
            TOOLBAR_TOOLS.EDIT_DRAWING,
            TOOLBAR_TOOLS.CAPTION,
            TOOLBAR_TOOLS.REACTION,
            ...TOOL_SETS.MULTI_SELECT_ARRANGEMENT,
        ],
        editingTools: [...TOOL_SETS.TEXT_EDITING_INLINE, TOOLBAR_TOOLS.TEXT_CENTERED],
    });
